<template>
    <section class="hero is-light is-fullheight" v-if="accessGranted">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-centered is-multiline">
            <router-link to="/demo-module/list" class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div>
                <img class="img-dashboard" src="@/assets/icons/Eye_pink_icon.png" >
                <p align="center">{{$t("tracking-demo-title")}}</p>
              </div>
            </router-link>

            <router-link v-if="!isTransporter && haveStockAccess" to="/demo-module/create" class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div>
                <img class="img-dashboard" src="@/assets/icons/Add_pinkgradient_icon.png">
                <p align="center">{{$t("demo-order-title")}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
</template>

<style>
.img-dashboard {
  display : block;
  margin: auto;
  width: 128px;
  height: 128px;
}
</style>
<script>

import deniedAccessMixin from '@/mixins/deniedAccessMixin'

export default {
  name: 'ExpeditionModule',
  mixins: [deniedAccessMixin],
  computed: {
    accessGranted(){
      const user = this.$store.state.user
      if (user === null) {
        return false
      } else {
        if(user.haveDemoAccess){
          return true
        }else{
          this.accessDeniedError()
          return false
        }
      }
    },
    user() {
      return this.$store.state.user
    },
    isTransporter () {
      if(this.user !== null) {
        return this.user.isTransporter
      }
      return false;
    },
    haveStockAccess(){
      if(this.user !== null) {
        return this.user.haveStockAccess
      }
      return false;
    }
  }
}
</script>
